import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectMicrositeWebsocketsState = createFeatureSelector<
  MicrositeWebsocketsState
>('micrositeWebsockets');

import { MicrositeWebsocketsState } from './coreWebsockets.models';

export const selectMicrositeWebsockets = 
createSelector(
  selectMicrositeWebsocketsState,
  (state: MicrositeWebsocketsState) => state
);

export const selectMicrositeWebsocketsBalance = 
createSelector(
  selectMicrositeWebsocketsState,
  (state: MicrositeWebsocketsState) => state.balance
);

export const selectMicrositeWebsocketsEvent = 
createSelector(
  selectMicrositeWebsocketsState,
  (state: MicrositeWebsocketsState) => state.currentEvent
);
